import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { decorateModuleRef } from './app/environment';

try {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(decorateModuleRef)
    .catch((err) => {
      console.error(err);
      if (err && err.stack) {
        console.error('Stack trace:', err.stack);
      }
    });
} catch (err) {
  console.error('Bootstrap error:', err);
  if (err && err.stack) {
    console.error('Stack trace:', err.stack);
  }
}
